import type { ComponentPropsWithoutRef } from "react";
import { useState } from "react";
import classNames from "classnames";
import { useAnyHoverMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { Icon } from "@circle-react-shared/Icon";
import { Dropdown } from "@circle-react-uikit/Dropdown";

const popperOptions = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 5],
      },
    },
  ],
};

export interface ThreeDotsDropdownProps
  extends ComponentPropsWithoutRef<typeof Dropdown> {
  contentPortalElement?: Element;
}

export const ThreeDotsDropdown = ({
  children,
  buttonClassName,
  contentPortalElement,
  ...rest
}: ThreeDotsDropdownProps) => {
  const canHover = useAnyHoverMediaQuery();
  const [hasDropdownOpen, setHasDropdownOpen] = useState(false);

  return (
    <Dropdown
      dataTestId="three-dots-dropdown-menu"
      button={
        <div
          className={classNames(
            "hover:bg-tertiary flex size-6 justify-center rounded",
            buttonClassName,
          )}
        >
          <Icon
            type="menu-dots"
            className="text-light"
            useWithFillCurrentColor
          />
        </div>
      }
      className={classNames("text-dark z-10 flex justify-end", {
        "group-hover:visible lg:invisible": canHover && !hasDropdownOpen,
      })}
      transitionWrapperClassName="z-50"
      buttonWrapperClassName="flex"
      popperOptions={popperOptions}
      {...rest}
      onToggle={setHasDropdownOpen}
      appendTo={contentPortalElement ?? document.body}
    >
      {children}
    </Dropdown>
  );
};
